import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { rotate } from '../theme/animation';
import { tokens, ICON_CLASS } from './tokens';
export var IconVariant = /*#__PURE__*/ function(IconVariant) {
    IconVariant["light"] = "light";
    IconVariant["bold"] = "bold";
    IconVariant["custom"] = "custom";
    return IconVariant;
}({});
export var NewIconVariant = /*#__PURE__*/ function(NewIconVariant) {
    NewIconVariant["default"] = "default";
    NewIconVariant["solid"] = "solid";
    NewIconVariant["mini"] = "mini";
    NewIconVariant["extended"] = "extended";
    return NewIconVariant;
}({});
export var IconSize = /*#__PURE__*/ function(IconSize) {
    IconSize["xxxs"] = "xxxs";
    IconSize["xxs"] = "xxs";
    IconSize["xs"] = "xs";
    IconSize["s"] = "s";
    IconSize["m"] = "m";
    IconSize["l"] = "l";
    return IconSize;
}({});
export function IconBase({ iconVariants, type, rotate, name, ...restProps }) {
    const Component = iconVariants[type];
    if (!Component) throw new Error(`Icon type "${type}" is not defined for "${name}"`);
    return /*#__PURE__*/ _jsx(Component, {
        rotate: rotate,
        ...restProps,
        "data-icon-name": name
    });
}
export const Icon = styled(IconBase)`
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentColor;
  display: inline-block;
  vertical-align: middle;
  font-size: ${({ size })=>tokens.Icon[size ?? 's'].size};
  ${(props)=>props.rotate && `transform: rotate(${props.rotate}deg);`}
  transform-origin: center center;
  ${(props)=>props.spin && css`
      animation: 1s ${rotate} linear infinite;
    `}
  ${(props)=>props.color && `color: ${props.color};`}

  /** This is temporarily for the DS2.0, in DS3.0 this is handled */
  ${({ strokeBased })=>strokeBased && css`
      path {
        stroke: currentColor;
        fill: none;
      }
    `}
`;
export function createIcons(name, iconVariants) {
    const CreatedIcon = /*#__PURE__*/ forwardRef((props, ref)=>{
        const type = props.type; //?? getDefaultType(props.type, CreatedIcon.supportedTypes);
        return /*#__PURE__*/ _jsx(Icon, {
            ...props,
            className: `${ICON_CLASS} ${props.className}`,
            ref: ref,
            type: type,
            iconVariants: iconVariants,
            name: name
        });
    });
    // added this line for typing support
    CreatedIcon.supportedTypes = [];
    return CreatedIcon;
}
export const IconWithUrl = styled.div`
  background-color: ${({ color })=>color};
  mask: url(${({ icon })=>icon});
  mask-size: ${({ size })=>`${size} ${size}`};
  mask-position: center;
  width: ${({ size })=>`${size}`};
  height: ${({ size })=>`${size}`};
`;
